// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vs-0";
export var checkoutRateBadgeLink = "_vs-1";